import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus, setCustomHandlerRegisterPlatformStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformManageRegisterPlatformMockHandler = () => {
  return http.post('*/manage/register-platform', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    setCustomHandlerRegisterPlatformStatus(true);

    return new HttpResponse(null, {
      status: 204,
    });
  });
};
